import React from "react";

const PageHero = ({ eyebrow, title, subtitle, image }) => {
  return (
    <section className="relative h-[46vh] min-h-[360px] flex items-center">
      <div className="absolute inset-0">
        <img src={image} alt={title} className="w-full h-full object-cover" />
        <div className="absolute inset-0 hero-overlay" />
      </div>
      <div className="relative max-w-7xl mx-auto px-6 md:px-8 w-full">
        <div className="max-w-2xl fade-up">
          {eyebrow && (
            <span className="text-xs tracking-luxury uppercase text-[#e3c98d]">{eyebrow}</span>
          )}
          <h1 className="font-display text-4xl md:text-6xl text-white leading-tight mt-3">
            {title}
          </h1>
          {subtitle && (
            <p className="text-[#efe6d6] text-lg mt-4 leading-relaxed max-w-xl">{subtitle}</p>
          )}
        </div>
      </div>
    </section>
  );
};

export default PageHero;
